/** @jsx jsx */
import { Box, Button, EmptyState, EmptyStateSadSquare } from "@eworkit/iris";
import { FC } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useQueryErrorResetBoundary } from "react-query";
import { jsx } from "theme-ui";

interface AppErrorBoundaryProps {}

export const AppErrorBoundary: FC<AppErrorBoundaryProps> = ({ children }) => {
  const { t } = useTranslation("public");

  const { reset } = useQueryErrorResetBoundary();

  return (
    <ErrorBoundary
      onReset={reset}
      fallbackRender={({ resetErrorBoundary }) => (
        <Box sx={{ pt: 140, pb: 180 }} px="sm">
          <EmptyState
            icon={<EmptyStateSadSquare />}
            title={t("ERROR_BOUNDARY.OOPS")}
            content={t("ERROR_BOUNDARY.SOMETHING_WENT_WRONG")}
            action={<Button onClick={resetErrorBoundary}>{t("ERROR_BOUNDARY.TRY_AGAIN")}</Button>}
          />
        </Box>
      )}>
      {children}
    </ErrorBoundary>
  );
};
